module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ContactUs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 form-class"
  }, [_vm._m(0), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Enter your name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.state
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Enter your email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.state
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Enter your message"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.state,
      "id": "message-box"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "signup_button hvr-grow"
  }, [_c('b-button', {
    attrs: {
      "size": "",
      "variant": "success",
      "href": ""
    }
  }, [_vm._v("\n          Sumbit\n        ")])], 1)], 1), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "heading-title"
  }, [_c('h1', [_vm._v("Contact Us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("Pair'd Team")]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-building-o",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("\n              SAP Vancouver\n            "), _c('br'), _vm._v("      910 Mainland St\n            "), _c('br'), _vm._v("      Vancouver, BC V6B 1A9\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_c('br'), _c('i', {
    staticClass: "fa fa-phone",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("   (604) 647-8888\n            "), _c('br'), _c('i', {
    staticClass: "fa fa-envelope",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v("   pair'd@sap.com\n          ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b01d5ce2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactus.vue
// module id = 41
// module chunks = 0